import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/packages/docs-site/src/components/containers/MdxLayout.js";
import { Playground, PropsTable } from '@versionone/doc-components';
import { Scrim } from './';
import { Button } from '../Button';
import { SpacedGroup } from '../SpacedGroup';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const StateManager = makeShortcode("StateManager");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`Scrims cover the underlying UI to allow the user to focus on a specific task in the elevated layer.`}</p>
    <Playground __position={0} __code={'{() => {\n    class StateManager extends React.Component {\n      constructor(props, context) {\n        super(props, context)\n        this.state = { isOpen: false }\n        this.toggle = this.toggle.bind(this)\n      }\n      toggle() {\n        this.setState({ isOpen: !this.state.isOpen })\n      }\n      render() {\n        return (\n          <SpacedGroup>\n            <Button onClick={this.toggle}>\n              {this.state.isOpen ? \'Close\' : \'Open\'}\n            \n            <Button onClick={() => console.log(\'clicked\')}>Click Me</Button>\n            <Scrim open={this.state.isOpen} onClick={this.toggle} />\n          </SpacedGroup>\n        )\n      }\n    }\n    return <StateManager />\n  }}\n</Playground>'} __scope={{
      props: this ? this.props : props,
      DefaultLayout,
      Playground,
      PropsTable,
      Scrim,
      Button,
      SpacedGroup
    }} mdxType="Playground">
  {() => {
        class StateManager extends React.Component {
          constructor(props, context) {
            super(props, context);
            this.state = {
              isOpen: false
            };
            this.toggle = this.toggle.bind(this);
          }

          toggle() {
            this.setState({
              isOpen: !this.state.isOpen
            });
          }

          render() {
            return <SpacedGroup mdxType="SpacedGroup">
            <Button onClick={this.toggle} mdxType="Button">
              {this.state.isOpen ? 'Close' : 'Open'}
            </Button>
            <Button onClick={() => console.log('clicked')} mdxType="Button">Click Me</Button>
            <Scrim open={this.state.isOpen} onClick={this.toggle} mdxType="Scrim" />
          </SpacedGroup>;
          }

        }

        return <StateManager mdxType="StateManager" />;
      }}
    </Playground>
    <h2>{`API`}</h2>
    <PropsTable of={Scrim} mdxType="PropsTable" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      